
import { createI18n } from 'vue-i18n';

// 语言包
import zhLocale from './zh';
import enLocale from './en';
const messages = {
    zh: zhLocale,
    en: enLocale,
}
// 语言切换
const localeLang = sessionStorage.getItem('language') // 当前选择的语言
const defaultBrowser = navigator.language.split('-')[0] === 'zh' ? 'zh' : 'en'; // 浏览器默认语言
const i18n = createI18n({
    globalInjection: true,
    locale: 'zh' || localeLang || defaultBrowser || 'en',
    messages,
    legacy: false,
})
export default i18n;